import { Input } from './components/form-fields/Input.js';
import { TextArea } from './components/form-fields/TextArea.js';
import { Select } from './components/form-fields/Select.js';
import { Checkbox } from './components/form-fields/Checkbox.js';
import { RadioGroup } from './components/form-fields/RadioGroup.js';
import { AddButton } from './components/form-fields/AddButton.js';
import { RemoveButton } from './components/form-fields/RemoveButton.js';
import { ArrayField } from './components/form-fields/ArrayField.js';
import { Hidden } from './components/form-fields/Hidden.js';

var FieldMap = {
  string: Input,
  number: Input,
  "boolean": Checkbox,
  select: Select,
  input: Input,
  textarea: TextArea,
  checkbox: Checkbox,
  radio: RadioGroup,
  add: AddButton,
  remove: RemoveButton,
  hidden: Hidden,
  array: ArrayField,
  withOptions: {
    string: Select
  }
};

export { FieldMap };
